import { GridReadyEvent, StatusPanelDef } from "ag-grid-community";
import { BaseAgGrid } from "../../components/grid/BaseAgGrid";
import { useCallback, useMemo, useRef } from "react";
import useKeywordsGridColumns from "./useKeywordsGridColumns";
import { SiteTransport } from "src/app/transports/site";
import { useIntl } from "react-intl";

const KeywordsGridContainer = () => {
    const { formatMessage } = useIntl();

    const gridReadyListener = useCallback(async (params: GridReadyEvent) => {
        params.api.setRowData(await SiteTransport.monitoring.kw());
    }, []);

    const gridRef = useRef(null);
    const statusBar = useMemo<{
        statusPanels: StatusPanelDef[];
    }>(() => {
        return {
            statusPanels: [{ statusPanel: "agTotalAndFilteredRowCountComponent", align: "left" }],
        };
    }, []);

    const gridColumns = useKeywordsGridColumns();

    return (
        <div className="ag-theme-balham" style={{ height: "100%" }}>
            <h2 className="mt-5">{formatMessage({ id: "analyse.sites.title.kw" })}</h2>
            <BaseAgGrid
                listHandler={() => {}}
                columnDefs={gridColumns}
                asCellFilter={false}
                gridRef={gridRef}
                onGridReady={gridReadyListener}
                debounceVerticalScrollbar={true}
                statusBar={statusBar}
                sideBar={null}
            />
        </div>
    );
};

export default KeywordsGridContainer;
